import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import FullWidthContainer from '@starbucks-web/pattern-library/lib/components/full-width-container';
import { Route, Routes } from 'react-router-dom';

import MenuBreadcrumbs from 'ordering/app/components/shared/menu-breadcrumbs';
import { currentRouteSelector } from 'shared/app/state/selectors/routes';
import ContentLoading from 'shared/app/components/content-crate-loading';
import { trackMOPProductDetailsView } from '../../state/actions/track-event';
import CallsToAction from './calls-to-action';
import MainContent from './main-content';
import NutritionContent from './nutrition-content';
import PdpHeader from './header';
import PdpProvider from './pdp-provider';
import SummaryAside from './summary-aside';
import errorMessages from '../../state/selectors/messages';
import { useFetchPricingMetadata } from './hooks/use-fetch-pricing-metadata';
import {
  productSelector,
  seoCanonicalUrlSelector,
} from '../../state/selectors';

const ProductDetailsPage = () => {
  const { formatMessage } = useIntl();
  useFetchPricingMetadata();

  const product = useSelector(productSelector) || {};
  const seoCanonicalUrl = useSelector(seoCanonicalUrlSelector);
  const location = useSelector(currentRouteSelector);

  const { description, name } = product;
  const isValidProduct =
    (product?.inCatalog || product?.inCatalog === undefined) &&
    Boolean(description) &&
    Boolean(name);
  useEffect(() => {
    if (product?.loading === false) {
      // eslint-disable-next-line camelcase
      trackMOPProductDetailsView({ menu_product_id: product.id });
    }
  }, []);

  return (
    <React.Fragment>
      <ContentLoading isContentLoading={product?.loading} />
      <Helmet>
        <title>{name}</title>
        {!isValidProduct && <meta content="noindex" name="robots" />}
        <meta content={description} property="description" />
        {seoCanonicalUrl && <link href={seoCanonicalUrl} rel="canonical" />}
      </Helmet>
      {isValidProduct ? (
        <React.Fragment>
          <MenuBreadcrumbs
            breadcrumbBarStyling
            className="sb-global-gutters sb-global-gutters--logoOffset text-xxs"
          />
          <PdpProvider product={product}>
            <PdpHeader />
            <FullWidthContainer className="pt5">
              <div className="relative">
                <Routes location={location}>
                  <Route path="/menu/product">
                    <Route
                      element={<MainContent />}
                      path=":productNumber/:formCode"
                    />
                    <Route
                      element={<NutritionContent />}
                      path=":productNumber/:formCode/nutrition"
                    />
                  </Route>
                </Routes>
                <CallsToAction />
              </div>
            </FullWidthContainer>
            <SummaryAside />
          </PdpProvider>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <PdpHeader />
          <p className="pt5 pl5">{formatMessage(errorMessages.emptyProduct)}</p>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ProductDetailsPage;
